import React, { useEffect, useState } from 'react'

import { InfoVolginsky, LiveInVolginsky, VacanciesVolginsky, PersonalVolginsky, QuestionsVolginsky } from './index'
import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const Relocation = ({ filterVacation, checkDomenNameState, ourRef, captchaSiteKey }) => {
  const [routeBlockVacancies, setRouteBlockVacancies] = useState(null)
  smoothscroll.polyfill()

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <InfoVolginsky routeBlockVacancies={routeBlockVacancies} />
      <LiveInVolginsky />
      <VacanciesVolginsky filterVacation={filterVacation} checkDomenNameState={checkDomenNameState} setRouteBlockVacancies={setRouteBlockVacancies} />
      <PersonalVolginsky />
      <QuestionsVolginsky />
    </div>
  )
}

export default Relocation
